import { AgencyPerson } from "./agencyPeople.service";

export function findPersonByEmail(
  people: AgencyPerson[],
  email: string,
): AgencyPerson | undefined {
  const normalized = email.trim().toLowerCase();
  return people.find((person) => person.email === normalized);
}

export function teamPersonIds(people: AgencyPerson[]): Set<string> {
  return new Set(people.filter((p) => p.kind === "team").map((p) => p.id));
}

/**
 * The name to send when adding an access email. For a known person the
 * untouched field holds a snapshot of their global name, and resending it
 * could overwrite a newer one. So a name goes out only when the user typed
 * it or the email is new.
 */
export function nameToSend(
  name: string,
  nameTouched: boolean,
  knownPerson: AgencyPerson | undefined,
): string | undefined {
  if (knownPerson && !nameTouched) return undefined;
  const trimmed = name.trim();
  return trimmed ? trimmed : undefined;
}

export const agencyPeopleKeys = {
  all: ["agency-people"] as const,
};

/** The agency's members, in server order, for the Setup Team panel.
 * Contacts are named in each client's access modal instead (DD-047). */
export function teamMembers(people: AgencyPerson[]): AgencyPerson[] {
  const ids = teamPersonIds(people);
  return people.filter((person) => ids.has(person.id));
}
